import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'




AOS.init({
  easing: 'ease-out-back',
  duration: 1000
});
const app = createApp(App);

app.use(store)
app.use(router)
app.use(VueApexCharts)
app.use(BootstrapVueNext)
app.component(VueFeather.type, VueFeather)
app.directive("maska", vMaska)
app.directive("can", {
  mounted(el, binding) {
    const user = store.getters["auth/getUser"];
    const permissions = user?.permissions || user?.data?.permissions || [];
    const requiredPermission = binding.value;

    if (user?.role === "admin") return; // admin bypass

    let hasPermission = false;

    if (typeof requiredPermission === "string") {
      hasPermission = permissions.some((p) => p.name === requiredPermission);
    } else if (Array.isArray(requiredPermission)) {
      hasPermission = requiredPermission.some((perm) =>
        permissions.some((p) => p.name === perm)
      );
    }

    if (!hasPermission) {
      el.style.display = "none";
    }
  }
});

app.use(i18n)
app.use(VueSweetalert2)
app.use(vClickOutside)
app.mount('#app');